module.exports = __webpack_public_path__ + "media/blog_send_animation.e71c57c4.mp4";